// inizializzo variabili per la complicance del lead;
let INPUT_IP_LABEL = 'leads[0][project_fields][ip]';
let INPUT_EVENT = 'event';
let INPUT_SOURCE_URL_LABEL = 'leads[0][project_fields][source_url]';
let INPUT_USER_AGENT_LABEL = 'leads[0][project_fields][user_agent]';
let INPUT_GCLID_LABEL = 'project_fields[gclid]';
let INPUT_PRIVACY_AFFIDA = 'leads[0][privacy][privacy]';
let INPUT_TERMINI_AFFIDA = 'leads[0][privacy][termini_condizioni]';
// inizializzo variabili di configurazione EGG
let INPUT_FONTE_TRAFFICO = 'leads[0][project_fields][egg_fonte_traffico]';
let INPUT_ID_FORNITORE = 'leads[0][project_fields][egg_id_lead_fornitore]';
let INPUT_CAMPAGNA_ID = 'leads[0][campaign]';
let INPUT_FORNITORE = 'leads[0][project_fields][egg_fornitore]';
let INPUT_CANALE = 'leads[0][project_fields][canale_di_provenienza]';
let INPUT_TIPOLOGIA = 'leads[0][project_fields][egg_tipologia_lead]';
let INPUT_PRODOTTO = 'leads[0][project_fields][egg_prodotto_finanziario]';

document.addEventListener("DOMContentLoaded", () => {
    const buttonDesktop = document.getElementById("button-cta-desktop");
    const buttonPhone = document.getElementById("button-cta-phone");
    const buttonGift = document.getElementById("energy-gift");
    const targetPhone = document.querySelectorAll(".show-line")[2];
    const target = document.querySelectorAll(".show-line")[1];
    const targetGift = document.querySelectorAll(".show-line")[3];
    
    if (buttonDesktop && target) {
        buttonDesktop.addEventListener("pointerdown", () => {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }
    if (buttonPhone && targetPhone) {
        buttonPhone.addEventListener("pointerdown", () => {
            targetPhone.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }
    if (buttonGift && targetGift) {
        buttonGift.addEventListener("pointerdown", () => {
            targetGift.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }
});

window.addEventListener('heyflow-screen-view', (event) => {
});

let shadowRoot;
window.addEventListener('heyflow-init', (event) => {
    console.log('heyflow init:', event);
    getImageMarketing();
    shadowRoot =
      (document.querySelector(`[flow-id="${event.detail.flowID}"]`) &&
        document.querySelector(`[flow-id="${event.detail.flowID}"]`)
          .shadowRoot) ||
      document;
    initFields();
    loadUserData();
    // insertIframe();    
});



window.addEventListener('heyflow-change', (event) => {
    console.log('heyflow change:', event.detail);
    let targetValue = event.detail.fieldsSimple['project_fields[professione]'];
    if(!!targetValue) {
        populateField('start', INPUT_TARGET, getTarget(targetValue));
    }
});


// inizializzo funzioni per la gestione dell'heyflow;
function initHiddenFields() {
    populateField('start', 'leads[0][project_fields][ip]', 1);
    populateField('start', 'leads[0][project_fields][source_url]', 1);
    populateField('start', 'leads[0][project_fields][user_agent]', 1);
    populateField('start', 'leads[0][privacy][privacy]', 1);
    populateField('start', 'leads[0][privacy][termini_condizioni]', 1);
}
function createHiddenInputField(name,id, value) {
    const input = document.createElement('input');
    input.type = 'hidden';
    // i valori di input name e id sono da valorizzare con la nomenclatura del mapping;
    // usata nel servizio di providing;
    // esempio 'privacy[newsletter]';
    input.name = name;
    // esempio 'privacy[newsletter]';
    input.id = id;
    input.value = value;
    // Aggiungo l'hidden field al form al primo form disponibile;
    document.addEventListener('DOMContentLoaded', () => {
        const form = document.getElementsByTagName('form')[0];
        form.appendChild(input);
    });
}
function populateField(sectionName, dataLabel, valueStr) {
    let element = getField(sectionName, dataLabel);
    // console.log(sectionName, dataLabel, valueStr, element);
    if (element) {
        element.value = valueStr;
    } else {
        console.log('element non trovato');
    }
    console.log({action: 'populate', field: dataLabel, value: valueStr})
}

function insertIframe() {
        const container = document.getElementById('trustpilot');
        if (!container) {
            console.error('Div with id "trustpilot" not found.');
            return;
        }
        
        const iframe = document.createElement('iframe');
        iframe.src ="https://widget.trustpilot.com/trustboxes/53aa8807dec7e10d38f59f32/index.html?templateId=53aa8807dec7e10d38f59f32&businessunitId=5e4b194c3fe4ff00011022b4#vCc193bce=&locale=it-IT&styleHeight=150px&styleWidth=100%25&theme=light";
        iframe.width = "100%";
        iframe.height = "600px";
        iframe.style.border = "none";
        
        container.appendChild(iframe);
    }

function getField(sectionName, dataLabel) {
    return shadowRoot.querySelector("section[name='" + sectionName +  "'] input[data-label='" + dataLabel + "']");
}

function getSelectField(sectionName, dataLabel) {
    return shadowRoot.querySelector("section[name='" + sectionName +  "'] select[data-label='" + dataLabel + "']");
}

function loadUserData() {
    var url = window.location.href;
    if(url.indexOf("lob:") > 0) {
        url = url.substring(5);
    }
    populateField('start', INPUT_SOURCE_URL_LABEL, url);
    const request = new XMLHttpRequest();
    request.open("GET", "https://api.ipify.org", false);
    request.send(null);
    if (request.status === 200) {
        populateField('start', INPUT_IP_LABEL, request.responseText);
    }
    populateField('start', INPUT_USER_AGENT_LABEL, navigator.userAgent);
    populateField('start', INPUT_PRIVACY_AFFIDA, '1');
    populateField('start', INPUT_TERMINI_AFFIDA, '1');
    const regex = new RegExp("(?<=gclid=).*?(?=&|\\s|$|#)", "g");
    const match = window.location.toString().match(regex);
    if (match) {
        populateField('start', INPUT_GCLID_LABEL, match[0]);
    }
}

function initFields() {
    populateField('start', INPUT_PRODOTTO, 'Cessione del Quinto');
    populateField('start', INPUT_EVENT, 'LEAD_AVAILABLE');
    populateField('start', INPUT_FORNITORE, 'Facebook');
    populateField('start', INPUT_CANALE, 'Digital Pillar CQ');
    populateField('start', INPUT_TIPOLOGIA, 'Web');
    populateField('start', INPUT_FONTE_TRAFFICO, 'facebook-branded');
    populateField('start', INPUT_CAMPAGNA_ID, 'WS_FACEBOOK_BRANDED_V2');
//    populateField('start', INPUT_CAMPAGNA_ID, 'WS_CAGLIARI_706_STD_SV_TO_EGG');
    populateField('start', INPUT_ID_FORNITORE, crypto.randomUUID());
}

function checkPropertiesAndPush(oggetto, proprieta, nota) {
    proprieta.forEach(item => {
        const [proprieta, prefisso] = item; // Estrai proprietà e prefisso
        if (oggetto.hasOwnProperty(proprieta) && oggetto[proprieta]) {
            if (!nota.includes(prefisso + oggetto[proprieta])) {
                nota.push(prefisso + oggetto[proprieta]);
                nota_composta = nota.join('\n');
                populateField('start', INPUT_NOTE, nota_composta);
            }
        }
    });
}

function getTarget(value) {
    switch (value) {
        case 'Dipendente pubblico':
            return 'Pubblico';
        case 'Dipendente statale':
            return 'Statale';
        case 'Dipendente ministeriale':
            return 'Statale';
        case 'Dipendente MEF':
            return 'Statale';
        case 'Dipendente parapubblico':
            return 'Parapubblico';
        case 'Dipendente Privato (Azienda con più di 16 dipendenti)':
            return 'Privato';
        case 'Dipendente Privato (Azienda con meno di 16 dipendenti)':
            return 'Privato';
        case 'Dipendente privato':
            return 'Privato';
        case 'Pensionato':
            return 'Pensionato';
        case 'Lavoratore autonomo/P.IVA':
            return 'Autonomo';
        default:
            // codice da eseguire se la professione non corrisponde a nessuno dei casi precedenti
            throw Error('Professione non valida');
    }
}

// Funzione per ottenere il parametro dall'URL
function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
}

function getImageMarketing() {
    // Recupera il valore del parametro "marketing-img"
    const marketingImg = getQueryParam("marketing-img");
    console.log({param: marketingImg});
    
    // Trova gli elementi img con alt specifico
    const images = {
        old: document.querySelector('div[data-blockid="id-f4e9a5b6"]'),
        young: document.querySelector('div[data-blockid="id-f946617e"]')
    };
    
    // Nasconde tutte le immagini inizialmente aggiungendo le classi
    Object.values(images).forEach(img => {
        if (img) {
            img.classList.add("hide_mobile", "hide_desktop");
        }
    });
    
    // Nascondo il loader
    const loader = document.querySelector('div[data-blockid="loader-6e85fee1"]');
    loader.classList.add(
                    // "hide_mobile",
                    "hide_desktop"
                    );
    // Gestisce la logica con uno switch-case
    switch (marketingImg) {
        case "old":
        console.log('old image');    
            if (images.old) {
                images.old.classList.remove(
                    // "hide_mobile",
                    "hide_desktop"
                    );
            }
            break;
        case "young":
        console.log('young image');
            if (images.young) {
                images.young.classList.remove(
                    // "hide_mobile", 
                    "hide_desktop"
                    );
            }
            break;
        default:
        console.log('default image');
            if (images.young) {
                    images.young.classList.remove(
                        // "hide_mobile", 
                        "hide_desktop");
                }
            break;
    }
}

